import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTalendComponent } from './simple-icons-talend.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTalendComponent ],
    exports:      [ SimpleIconsTalendComponent ],
    bootstrap:    []
})
export class SimpleIconsTalendModule {}
